var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"carrier-logo",style:({ width: (_vm.size + "px"), height: (_vm.size + "px") }),attrs:{"alt":"","src":_vm.failed || !_vm.src ? _vm.placeholder : _vm.src},on:{"error":function($event){_vm.failed = true}}})}
var staticRenderFns = []

export { render, staticRenderFns }